import { EventEmitterFactory } from 'pf-frontend-common/src/module/event/emitter.factory';
import { ModalService } from 'pf-frontend-common/src/service/modal/service';

import { PropertyCtaStatechartService } from 'common/module/property-cta/statechart/service';
import { UserAuthenticationService } from 'common/service/user-authentication/service';
import { LeadPhoneViewStore } from 'mobile/module/lead/phone/view-store';

export function LeadPhoneViewStoreFactory(): LeadPhoneViewStore {
  return new LeadPhoneViewStore(
    EventEmitterFactory(),
    PropertyCtaStatechartService(),
    UserAuthenticationService(),
    ModalService()
  );
}
